import { createContext } from "react";
import { useEffect, useState } from 'react';
import { fetchApi } from './fetchAPI';

export const DataContext = createContext(null);



export const ContextLayout = ({ children }) => {
	const [data, setData] = useState({ pages: []});
	useEffect(() => {
		let data;
		async function ReadData() {
			data = await fetchApi('/peex.json');
			setData(data);
		};
		ReadData();
	}, []);
  return (
    <DataContext.Provider value={data}>
			{children}
    </DataContext.Provider>
  );
};
